// The code in this file will load on every page of your site
import { updateBooksRepeater } from 'public/books.js'
import {session} from 'wix-storage';
import wixLocation from 'wix-location';
import wixSite from 'wix-site';

export var previousPageURL;
export var previousPageName;

$w.onReady( function() {
	$w("#searcBtn").show()
	if($w("#searchInput").value == "" || $w("#searchInput").value === undefined){
		$w("#clean").hide();
	}
	previousPageURL = session.getItem("pageURL");
	previousPageName = session.getItem("pageName");
	if(wixSite.currentPage.name !== "דף מוצר") {
		session.setItem("pageURL", wixLocation.url);
		session.setItem("pageName", wixSite.currentPage.name);
	}
	
	if (wixSite.currentPage.name !== "ספרים") {
		$w("#searchInput").onKeyPress( (event) => {
        	if(event.key === "Enter"){
				redirectTosearchPage();
        	}
    	})
		$w("#searcBtn").onClick(e => {
			redirectTosearchPage();
		})
	}	
});

function redirectTosearchPage(){
	if($w("#searchInput").value !== ""){
		wixLocation.to("/ספרים?searchParameter=" + $w("#searchInput").value);
	}
}

export function compareCreatorTypes(a, b) {	
  if (a.sort_order > b.sort_order) return 1;
  if (b.sort_order > a.sort_order) return -1;
  return 0;
}

export function compareCreatorGroup(a, b) {	
  if (a.sort_order > b.sort_order) return 1;
  if (b.sort_order > a.sort_order) return -1;
  return 0;
}

export function clean_click(event) {
	wixLocation.queryParams.remove(["searchParameter"]);
	$w("#clean").hide()
	$w("#searcBtn").show()
	$w("#searchInput").value = "";

	try {
		$w("#title").text = "כל הספרים";
		updateBooksRepeater("#booksRepeater", "הכל");
        // for mobile view
        $w("#menuContainer1").close();
    } catch {}
}